import React from 'react';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';

import { SortOrder } from 'enums';

import { EnhancedTableHeadProps } from './table-types';

const NOOP = () => {};

export function EnhancedTableHead(props: EnhancedTableHeadProps) {
  const {
    classes,
    order: dataOrder,
    orderBy,
    onRequestSort,
    columns,
    expandableRows,
  } = props;
  const createSortHandler = (property: string) => (
    event: React.MouseEvent<unknown>
  ) => {
    onRequestSort(event, property);
  };

  const order = dataOrder === SortOrder.ASC ? 'asc' : 'desc';

  return (
    <TableHead classes={{ root: classes.header }}>
      <TableRow>
        {expandableRows && <TableCell width={50} />}
        {columns.map(({ id, label, disableSort = false }) => (
          <TableCell
            className={disableSort ? undefined : classes.headerCell}
            key={id}
            align={'left'}
            sortDirection={orderBy === id ? order : false}
            onClick={disableSort ? NOOP : createSortHandler(id)}
          >
            {disableSort ? (
              label
            ) : (
              <TableSortLabel
                active={orderBy === id}
                direction={orderBy === id ? order : 'asc'}
              >
                {label}
                {orderBy === id ? (
                  <span className={classes.visuallyHidden}>
                    {dataOrder === SortOrder.DESC
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
